<app-nav-menu></app-nav-menu>
<div>
  <ng-template #bad let-modal>

    <div class="modal-success">
      <img class="sucesspopup" src="assets/img/badicon.gif" />

      <h2 class="textpopupbad"> Not Saved!</h2>
      <h5 class="textsubheadpopup"> Please Try Again!</h5>
      <button class="okButton" (click)="modal.dismiss()">Ok</button>

    </div>


  </ng-template>
</div>
<div>
  <ng-template #validatesd let-modal>

    <div class="modal-body">
      <div style="display:flex;align-content:center;justify-content:center;">
        <svg style="color: red" xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
        <!--<img class="sucesspopup_new" src="assets/img/badicon.gif" />-->
      </div>

      <div style="display:flex;align-content:center;justify-content:center;">
        <h2 class="textpopupbad_new"> Over lapped!</h2>
      </div>
      <div style="text-align: center; color: red; font-weight: bold;">

        {{validatecheckmessage}} {{validateforwardmessage}}
      </div>
      <!--<div style="display: flex; align-content: center; justify-content: center; color: red; font-weight: bold;">


    </div>-->

    <div class="marginbtnlft">
      <div style="padding:12px">
        <button class="yesButton" (click)="YesMovedToOldRevenue()">Yes!</button>
      </div>
      <div style="padding:12px">
        <button class="noButton" (click)="modal.dismiss()">No</button>
      </div>
    </div>
  </div>


</ng-template>
</div>
<div>

</div>
<div class="bodyofvoidreve" style="background-color:white;width:100%;height:100vh;">
  <div style="padding:20px 80px 10px 80px; letter-spacing:1px">
    <div style="padding: 10px; background-color: white; box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; width: 100%; border-radius: 5px; ">
      <div class="row m-0 mb-2">

        <div class="col-md-12" style="font-weight: bold; color: var(--first-color-second); font-size: 22px; padding: 19px; letter-spacing: 2px; justify-content: center; align-items: center; display: flex; ">
          Refund Revenue Manage

        </div>
      </div>
      <div class="fadeInUp animated">
        <div class="row m-0">
          <div class="col-md-3">
            <label>Name</label>
            <input type="text" name="name" [(ngModel)]="revenueObj.name" id="name" class="main_text-box" />
            <span class="messgereq" id="messagename"></span>
          </div> <!--[(ngModel)]="revenueObj.agencyId_BranchId"-->
          <div class="col-md-3 pl-0">
            <label>Agency Branch</label>
            <ng-select #agency_brancch [items]="agency_branchesList$ | async" placeholder="Agency_Branch"
              bindLabel="name" bindValue="code" class="multiselect" [searchable]="true" [(ngModel)]="revenueObj.agencyBranchList"
              id="agencybranch" [multiple]="true"
              (change)="ChangeAgency_Branch(revenueObj.agencyBranchList)">
            </ng-select>
            <span class="messgereq" id="messageagency"></span>
          </div>
          <div class="col-md-2 pl-0">
            <label>Expiry Date</label>
            <input type="date" name="expiryDate" min="{{minDate}}" (blur)="dateexpvalidate(revenueObj.expiryDate)" id="expiryDate" [(ngModel)]="revenueObj.expiryDate" class="main_text-box" />
            <span class="messgereq" id="messageexpiryDate"></span>
          </div>
          <div class="col-md-2 pl-0">
            <label>Suppliers</label>
            <ng-select #supplier [items]="supplierList$ | async" placeholder="Suppliers" multiple="true"
              class="revenuedropdown multiselect newvoidrevsp"
              bindLabel="name"
              bindValue="supplierId"
              [searchable]="true"
              id="supplierd"
              [(ngModel)]="revenueObj.selectedSuppliersList"
              (change)="ChangeSupplier(revenueObj.selectedSuppliersList)">
            </ng-select>
            <span class="messgereq" id="messagesupplierd"></span>
          </div>
          <div class="col-md-2 pl-0">
            <label>Office ID</label>
            <input type="checkbox" [(ngModel)]="revenueObj.isOficeId" id="checkoffice" class="red-input" style="margin-left: 20px;" />

            <ng-select #oficeId [items]="oficeIdList$ | async" placeholder="Office ID" multiple="true"
              class="revenuedropdown multiselect newvoidofice"
              bindLabel="officeId" bindValue="officeId" [searchable]="true"
              [(ngModel)]="revenueObj.selectedOficeIdsList"
              for="ofc"  id="abc">
            </ng-select>
            <span class="messgereq" id="messageisOficeId"></span>
          </div>
        </div>

        <div class="row m-0 mt-2">
          <div class="col-md-6">


            <div class="row m-0" style="font-weight: bold;">
              <div class="col-md-4 p-0">
                Applied On:
              </div>
              <div class="col-md-4 p-0 pl-3">
                Type:
              </div>
              <div class="col-md-4 p-0 pl-3">
                Applies On:
              </div>
            </div>
            <div class="row m-0 mt-2">
              <div class="col-md-4 p-0 ">
                <div>
                  <input type="checkbox" [(ngModel)]="revenueObj.applyChildAgency" class="red-input" style=" max-width: 11.5%;" />
                  <label style="margin-left: 10px;">Child Agencies</label>
                </div>
                <div>
                  <input type="checkbox" class="red-input" [(ngModel)]="revenueObj.applyChildBranches" />
                  <label style="margin-left: 10px;">Child Branches</label>
                </div>
                <div>
                  <input type="checkbox" class="red-input" [(ngModel)]="revenueObj.applyHO" />
                  <label style="margin-left: 10px;">HO</label>
                </div>
                <span class="messgereq" id="messageApplyOn"></span>
              </div>
              <div class="col-md-4 p-0 pl-3" style="border-left:1px solid black">
                <div>
                  <input type="radio" (change)="ChangeType($event.target.value)" [checked]="isServiceFee" value="ServiceFee" name="ServiceFee" class="option-inputs radio" style=" max-width: 11.5%;" />
                  <label style="margin-left: 10px;">Service Fee</label>
                </div>
                <span class="messgereq" id="messagetypesefe"></span>
              </div>
              <div class="col-md-4 p-0 pl-3" style="border-left:1px solid black">
                <div>
                  <input type="radio" (change)="ChangeAppliesOn($event.target.value)" [checked]="isPassenger" value="Passenger" name="isPassenger" class="option-inputs radio" style=" max-width: 11.5%;" />
                  <label style="margin-left: 10px;">Passenger</label>
                </div>
                <!--<div>
                <input type="radio" name="isPNR" value="PNR" [checked]="isPNR" (change)="ChangeAppliesOn($event.target.value)" class="option-inputs radio" style=" max-width: 11.5%;" />
                <label style="margin-left: 10px;">PNR</label>
              </div>-->
              <span class="messgereq" id="messageApplied"></span>
            </div>
          </div><!--style="margin-top: 31px; max-width: 11.5%; "-->

        </div>
        <div class="col-md-6">

          <label>Description</label>
          <textarea class="main_text-box" [(ngModel)]="revenueObj.description" name="remarks" id="tktRemarks" cols="120" rows="8" style="height:86px"></textarea>


        </div>

      </div>
      <!--criteria start-->
      <!--<hr class="dashed">
      <div class="row justify-content-center" style="color:var(--first-color-second);font-size:20px;letter-spacing:2px;text-decoration:underline;font-weight:bold;">
        Criteria
      </div>-->

      <!--travel date or booking date-->
      <!--<div class="row m-0 mt-3">
      <div class="col-md-6">
        <div class="row m-0">


          <div class="col-md-4 ">
            <div class="mt-4">
              <input type="checkbox" name="isTravelDate" [(ngModel)]="revenueObj.isTravelDate" class="red-input" style=" max-width: 11.5%;" />
              <label style="margin-left: 10px;" class="headoflabel">Travel Date</label>
            </div>
          </div>
          <div class="col-md-4 p-0 pl-2">
            <label>From Date</label>
            <input type="date" id="travelFrom" [(ngModel)]="revenueObj.travelDateFrom" name="travelFrom" class="main_text-box" (input)="trvlchk($event)" />
            <span class="messgereq" id="travelrequiredfrom"></span>

          </div>
          <div class="col-md-4 p-0 pl-2">
            <label>To Date</label>
            <input type="date" name="travelTo" id="travelTo" [(ngModel)]="revenueObj.travelDateTo" class="main_text-box" (input)="trvlchk($event)" />
            <span class="messgereq" id="travelrequiredto"></span>
          </div>
        </div>
      </div>
      <div class="col-md-6" style="border-left:1px solid black">
        <div class="row m-0">


          <div class="col-md-4 ">
            <div class="mt-4">
              <input type="checkbox" name="isBookingDate" [(ngModel)]="revenueObj.isBookingDate" class="red-input" style=" max-width: 11.5%;" />
              <label style="margin-left: 10px;" class="headoflabel">Booking Date</label>
            </div>

          </div>
          <div class="col-md-4 p-0 pl-2">
            <label>From Date</label>
            <input type="date" id="bookingFrom" name="bookingFrom" [(ngModel)]="revenueObj.bookingDateFrom" class="main_text-box" (input)="bkchk($event)" />
            <span class="messgereq" id="bookingdateform"></span>
          </div>
          <div class="col-md-4 p-0 pl-2">
            <label>To Date</label>
            <input type="date" id="bookingTo"
              [(ngModel)]="revenueObj.bookingDateTo"
              name="bookingTo" class="main_text-box" (input)="bkchk($event)" />
              <span class="messgereq" id="bookingdateto"></span>
            </div>
          </div>
        </div>

      </div>-->
      <!--location start-->
      <!--inclusion-->
      <!--<div class="row m-0 mt-4">
      <div class="col-md-2 pl-4">
        <div class="mt-4 pl-1">
          <input type="checkbox" name="isLocation" [(ngModel)]="revenueObj.isLocation" class="red-input" style=" max-width: 11.5%;" />
          <label style="margin-left: 10px;" class="headoflabel">Location Inclusion</label>
        </div>
      </div>
      <div class="col-md-3">
        <label>From</label>
        <ng-select #airportFrom class="revenuedropdown multiselect newvoidrevsp"
          [items]="airportsList$ | async" placeholder="From" multiple="true"
          bindLabel="cityName" bindValue="iATA_CODE" [searchable]="true"
          [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedFromLocation"
          (change)="FromAirportChange(selectedFromLocation)" (input)="lcchk($event) ">
        </ng-select>
        <span class="messgereq" id="messagesupplierd"></span>
      </div>
      <div class="col-md-3">
        <label>To</label>
        <ng-select #airportTo [items]="airportsList$ | async" placeholder="To" class="revenuedropdown multiselect newvoidrevsp"
          multiple="true" bindLabel="cityName" bindValue="iATA_CODE" [searchable]="true"
          [(ngModel)]="selectedToLocation" name="selected"
          (change)="ToAirportChange(selectedToLocation)">
        </ng-select>
        <span class="messgereq" id="messagesupplierd"></span>
      </div>
      <div class="col-md-4">
        <label>Via</label>
        <ng-select #airportTo [items]="airportsList$ | async" placeholder="Via" class="revenuedropdown multiselect newvoidrevsp"
          multiple="true" bindLabel="cityName" bindValue="iATA_CODE" [searchable]="true"
          [(ngModel)]="selectedVIALocation"
          name="selected">
        </ng-select>
        <span class="messgereq" id="messagesupplierd"></span>
      </div>
    </div>-->
    <!--exclusion start-->
    <!--<div class="row m-0 mt-4">
    <div class="col-md-2 pl-4">
      <div class="mt-4 pl-1">

        <label style="margin-left: 25px;" class="headoflabel">Location Exclusion</label>
      </div>
    </div>
    <div class="col-md-3">
      <label>From</label>
      <ng-select #airportFrom [items]="airportsList$ | async" placeholder="From"
        class="revenuedropdown multiselect newvoidrevsp" multiple="true"
        bindLabel="cityName" bindValue="iATA_CODE" [searchable]="true"
        [ngModelOptions]="{standalone: true}" [(ngModel)]="excludedFromLocation"
        (input)="lcchk($event) ">
      </ng-select>
      <span class="messgereq" id="messagesupplierd"></span>
    </div>
    <div class="col-md-3">
      <label>To</label>
      <ng-select #airportTo class="revenuedropdown multiselect newvoidrevsp"
        [items]="airportsList$ | async" placeholder="To" multiple="true"
        bindLabel="cityName" bindValue="iATA_CODE" [searchable]="true"
        [(ngModel)]="excludedToLocation" name="selected">
      </ng-select>
      <span class="messgereq" id="messagesupplierd"></span>
    </div>
    <div class="col-md-4">
      <label>Via</label>
      <ng-select class="revenuedropdown multiselect newvoidrevsp" #airportTo [items]="airportsList$ | async" placeholder="Via"
        multiple="true" bindLabel="cityName" bindValue="iATA_CODE" [searchable]="true"
        [(ngModel)]="excludedVIALocation"
        name="selected">
      </ng-select>
      <span class="messgereq" id="messagesupplierd"></span>
    </div>
  </div>-->
  <!--direction start-->
  <!--<div class="row m-0 mt-4">
  <div class="col-md-2 p-0 pl-4">
    <div class="mt-4 pl-1">
      <input type="checkbox" name="isDirection" [(ngModel)]="revenueObj.isDirection" class="red-input" style=" max-width: 11.5%;" />
      <label style="margin-left: 10px;" class="headoflabel">Direction</label>
    </div>
  </div>
  <div class="col-md-2">
    <div class="mt-4">
      <input type="checkbox" name="oneWayDirection" [(ngModel)]="revenueObj.oneWayDirection" value="OneWay" (change)="ChangeDirection($event)" class="red-input" style=" max-width: 11.5%;" />
      <label style="margin-left: 10px;">One way</label>
    </div>
  </div>
  <div class="col-md-2">
    <div class="mt-4">
      <input type="checkbox" name="multiTripDirection" [(ngModel)]="revenueObj.multiTripDirection" value="MultiCity" (change)="ChangeDirection($event)" class="red-input" style=" max-width: 11.5%;" />
      <label style="margin-left: 10px;">Multicity</label>
    </div>
  </div>
  <div class="col-md-2">
    <div class="mt-4">
      <input type="checkbox" name="roundTripDirection" [(ngModel)]="revenueObj.roundTripDirection" value="RoundTrip" (change)="ChangeDirection($event)" class="red-input" style=" max-width: 11.5%;" />
      <label style="margin-left: 10px;">Round Trip</label>
    </div>
  </div>
  <div class="col-md-4">

  </div>
  <span class="messgereq" id="directionrequired"></span>
</div>-->
<!--airline start-->
<!--<div class="row m-0 mt-4">
<div class="col-md-2 p-0 pl-4">
  <div class="mt-4 pl-1">
    <input type="checkbox" name="isValidatingAirline" [(ngModel)]="revenueObj.isValidatingAirline" class="red-input" style=" max-width: 11.5%;" />
    <label style="margin-left: 10px; " class="headoflabel">Validating Airline</label>
  </div>
</div>
<div class="col-md-4">

  <label>Validate Airline</label>
  <ng-select #validating [items]="airlineList$ | async"
    class="revenuedropdown multiselect newvoidrevsp" id="iam"
    multiple="true"
    placeholder="Validating Airline"
    bindLabel="airlineName"
    bindValue="airlineCombineCode"
    [searchable]="true"
    [(ngModel)]="selectedValidatingAirline" (input)="valchk($event)" (change)="validatechk()">
  </ng-select>
</div>

<div class="col-md-2 " style="padding:0px 30px;border-left:1px solid black">
  <div class="mt-4 ">
    <input type="checkbox" name="isMarketingAirline" [(ngModel)]="revenueObj.isMarketingAirline" class="red-input" style=" max-width: 11.5%;" />
    <label style="margin-left: 10px;" class="headoflabel">Marketing Airline</label>
  </div>
</div>
<div class="col-md-4">
  <label>Market Airline</label>
  <ng-select #marketing [items]="airlineList$ | async"
    id="your"
    class="revenuedropdown multiselect newvoidrevsp"
    multiple="true"
    placeholder="Marketing Airline"
    bindLabel="airlineName"
    bindValue="airlineCombineCode"
    [searchable]="true"
    [(ngModel)]="selectedMarkitingAirline"
    (input)="markchk($event)"
    (change)="marketingchk()">
  </ng-select>
</div>
</div>-->
<!--airline or tour code-->
<!--<div class="row m-0 mt-4">
<div class="col-md-2 p-0 pl-4">
  <div class="mt-4 pl-1">
    <input type="checkbox" name="isOperatingAirline" [(ngModel)]="revenueObj.isOperatingAirline" class="red-input" style=" max-width: 11.5%;" />
    <label style="margin-left: 10px; " class="headoflabel">Operating Airline</label>
  </div>
</div>
<div class="col-md-4">

  <label>Operating Airline</label>
  <ng-select #operating class="revenuedropdown multiselect newvoidrevsp"
    [items]="airlineList$ | async" id="apna" multiple="true"
    placeholder="Operating Airline" bindLabel="airlineName"
    bindValue="airlineCombineCode" [searchable]="true"
    [(ngModel)]="selectedOperatingAirline" (input)="operchk($event)"
    (change)="operatingchk()">
  </ng-select>
</div>

<div class="col-md-2 " style="padding:0px 30px;border-left:1px solid black">
  <div class="mt-4 ">
    <input type="checkbox" name="isTourCode" [(ngModel)]="revenueObj.isTourCode" class="red-input" style=" max-width: 11.5%;" />
    <label style="margin-left: 10px;" class="headoflabel">Tour Code</label>
  </div>
</div>
<div class="col-md-4">
  <label>Tour Code</label>
  <input type="text" id="tbtourCode" name="tbtourCode" placeholder="Tour Code" autocomplete="off" [(ngModel)]="revenueObj.tourCode" class="main_text-box" />
  <span class="messgereq" id="tourrequired"></span>
</div>
</div>-->
</div>
<!--Flight Calcultaion start-->
<hr class="dashed">
<div class="row justify-content-center mt-3" style="color: var(--first-color-second); font-size: 20px; letter-spacing: 2px; text-decoration: underline; font-weight: bold">
  Flight Calcultaion
</div>
<div class="row m-0 justify-content-end pr-4">
  <button class="addnewbtn" (click)="AddFlightCalculation()">
    <i class="fas fa-plus-circle"></i> Add New
  </button>

</div>
@for (dynamic of flightCalculations; track dynamic; let i = $index) {
  <div class="flightsdetails mt-4">
    <div class="row m-0">
      <div class="col-md-6">
        <label><span style="font-weight:bold;">Sr:</span> {{i+1}}</label>
      </div>
      <div class="col-md-6 ">
        <div class="row justify-content-end">
          <a class="card_button-delete" (click)="DeleteFlightCalculation(i)">
            <i class="uil uil-trash-alt card_button-del"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="row m-0 mt-4 ">
      <div class="col-md-2">
        <label>Type</label>
        <ng-select class="revenuedropdown multiselect newvoidrevsp"
          name="passenger{{i}}" #passenger [items]="passengerTypeList"
          bindLabel="type" bindValue="type" [searchable]="true"
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="dynamic.passengerType">
        </ng-select>
        <span class="messgereq" id="messagesupplierd"></span>
      </div>
      <div class="col-md-2">
        <label>Cabin Class</label>
        <ng-select name="cabinClass{{i}}" #cabin [items]="cabinClassList" class="revenuedropdown multiselect newvoidrevsp"
          bindLabel="cabinType" bindValue="cabinType" [searchable]="true" [ngModelOptions]="{standalone: true}"
          [(ngModel)]="dynamic.cabinClass">
        </ng-select>
        <span class="messgereq" id="messagesupplierd"></span>
      </div>
      <div class="col-md-2">
        <label>RBD</label>
        <ng-select name="rbd{{i}}" #rbd [items]="rbdList" multiple="true" class="revenuedropdown multiselect newvoidrevsp"
          bindLabel="rbdType" bindValue="rbdType" [searchable]="true" [ngModelOptions]="{standalone: true}"
          [(ngModel)]="dynamic.selectedRbd">
        </ng-select>
        <span class="messgereq" id="messagesupplierd"></span>
      </div>
      <div class="col-md-2">
        <label>Calculated On</label>
        <ng-select name="calculatedOn{{i}}" #calculatedon [items]="calculatedOnList" class="revenuedropdown multiselect newvoidrevsp" bindLabel="calculateType" bindValue="calculateType" [searchable]="true" [ngModelOptions]="{standalone: true}"
          [(ngModel)]="dynamic.calculatedOn">
        </ng-select>
        <span class="messgereq" id="messagesupplierd"></span>
      </div>
      <div class="col-md-2">
        <label>Value Amount</label>
        <input type="number" name="valueAmount{{i}}" (change)="flightvaluesamountchanges(i,dynamic.valueAmount)" class="main_text-box" id="valueAmount{{i}}"  [(ngModel)]="dynamic.valueAmount" />
        <span class="messgereq" id="messagesupplierd"></span>
      </div>
      <div class="col-md-2">
        <label>Value Percent</label>
        <input type="number" name="valuePercent{{i}}" (change)="flightvaluespercentchanges(i,dynamic.valuePercent)" id="valuePercent{{i}}" class="main_text-box" [(ngModel)]="dynamic.valuePercent" />
        <span class="messgereq" id="messagesupplierd"></span>
      </div>
      <div style="display:flex;width:100%;justify-content:end;">
        <span class="messgereq" style=" margin-right: 12px; margin-top: 14px;" id="valuePercentmessage{{i}}"></span>
      </div>
    </div>
  </div>
}
<div class=" row justify-content-end m-0 mt-2 pr-4">
  <span class="messgereq" style="font-size:18px" id="requirefldmsg"></span>
</div>
<!--button start-->
<div class="row m-0 mt-4 mr-2" style="display: flex; justify-content: right;">
  <div>
    <button class="button-iMAGE mr-2" id="btnSave" (click)="onSaveData(bad,validatesd)">{{buttonName}}</button>
  <!--</div>
  <div class="col-sm-2">-->
    <button class="cancel_buttons" id="btnCancel" [routerLink]="['/revenueManagementList']">Cancel</button>
  </div>
</div>
</div>
</div>

</div>
